import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, TextBox } from "../../../../components";
import CreateTenderingContext, {
  TENDERING_CREATE_STEPS,
} from "../CreateTenderingContext";
import _ from "lodash";
import ImageCropperEx from "../../../../components/common/ImageCropperEx";

const Split = ({ gridTemplateColumns, columns, children }) => {
  const style = {
    gridTemplateColumns: `repeat(${columns ?? 2}, minmax(auto, 1fr))`,
  };

  if (gridTemplateColumns) {
    style.gridTemplateColumns = gridTemplateColumns;
  }

  return (
    <div
      className="tendering-create__design-images__form__split"
      style={{ ...style }}
    >
      {children}
    </div>
  );
};

// TODO: Add file size limits
const ConstructionImages = (props) => {
  const { goBackward, goForward, details, setDetails, setCurrentStep } =
    useContext(CreateTenderingContext);
  const [cover, setCover] = useState(details?.images?.cover ?? undefined);
  const [gallery, setGallery] = useState(details?.images?.gallery ?? []);
  const [renderings, setRenderings] = useState(
    details?.images?.renderings ?? []
  );
  const [finalImages, setFinalImages] = useState(
    details?.images?.finalImages ?? []
  );

  useEffect(() => {
    setCurrentStep(TENDERING_CREATE_STEPS.IMAGES);
  }, []);

  const handleGoForward = () => {
    setDetails((curr) => ({
      ...curr,
      images: {
        cover,
        gallery,
        renderings,
        finalImages,
      },
    }));
    goForward();
  };

  return (
    <div className="tendering-create__design-images">
      <h3>Upload your Images</h3>
      <div className="tendering-create__design-images__image">
        <h4>Cover Images</h4>
        <ImageCropperEx
          aspectRatio={2}
          name={"cover"}
          multiple={false}
          onChange={(images) => {
            let _cover = images.length > 0 ? images[0] : undefined;

            setCover(_cover);
          }}
          cropperHeight={340}
          defaultImages={cover ? [cover] : undefined}
        />
      </div>
      <div className="tendering-create__design-images__divider" />
      <div className="tendering-create__design-images__image">
        <div className="tendering-create__design-images__sub-heading">
          <h4>Gallery</h4>
          <div>({gallery.length}/9)</div>
        </div>
        <ImageCropperEx
          aspectRatio={0.9}
          name={"galleryImage"}
          multiple={true}
          withGallery={true}
          onChange={(images) => {
            setGallery(images);
          }}
          cropperHeight={340}
          defaultImages={gallery}
          limit={9}
        />
      </div>
      <div className="tendering-create__design-images__divider" />
      <div className="tendering-create__design-images__image">
        <div className="tendering-create__design-images__sub-heading">
          <h4>3D Renderings</h4>
          <div>({renderings.length}/9)</div>
        </div>
        <ImageCropperEx
          aspectRatio={0.9}
          name={"renderings"}
          multiple={true}
          withGallery={true}
          onChange={(images) => {
            setRenderings(images);
          }}
          cropperHeight={340}
          defaultImages={renderings}
          limit={9}
        />
      </div>
      <div className="tendering-create__design-images__divider" />
      {details._id && (
        <div className="tendering-create__design-images__image">
          <div className="tendering-create__design-images__sub-heading">
            <h4>Picture after finished</h4>
            <div>({finalImages.length}/9)</div>
          </div>
          <h5>These pictures will replace the cover photo</h5>
          <ImageCropperEx
            aspectRatio={2}
            name={"finalImages"}
            multiple={true}
            withGallery={true}
            onChange={(images) => {
              setFinalImages(images);
            }}
            cropperHeight={340}
            defaultImages={finalImages}
            limit={9}
          />
        </div>
      )}
      <div className="tendering-create__design-images__footer">
        <Button
          label="Back"
          variant={"secondary"}
          onClick={() => goBackward()}
        />
        <Button label="Next" disabled={!cover} onClick={handleGoForward} />
      </div>
    </div>
  );
};

ConstructionImages.propTypes = {};

export default ConstructionImages;
